import { MutationNames } from '../generated/mutationsNames';

// Required as Knip does not recognise use of all keys in `Object.keys()` call.
/** @internal */
export enum ExcludedMutationNames {
    AccreditationsEmailsEstimate = MutationNames.AccreditationsEmailsEstimate,
    AssignmentsEmailsEstimate = MutationNames.AssignmentsEmailsEstimate,
    BackofficeEventUnarchive = MutationNames.BackofficeEventUnarchive,
    BackofficeInvoiceMarkAsPaid = MutationNames.BackofficeInvoiceMarkAsPaid,
    BackofficeOrganizationUpdate = MutationNames.BackofficeOrganizationUpdate,
    BackofficeOrganizationUserAdd = MutationNames.BackofficeOrganizationUserAdd,
    BackofficeOrganizationUserRemove = MutationNames.BackofficeOrganizationUserRemove,
    CampaignEstimate = MutationNames.CampaignEstimate,
    DelegationsExport = MutationNames.DelegationsExport,
    DelegationsImportResult = MutationNames.DelegationsImportResult,
    DomainDkimVerificationRetry = MutationNames.DomainDkimVerificationRetry,
    EmailFormInviteSend = MutationNames.EmailFormInviteSend,
    EmailResend = MutationNames.EmailResend,
    EmailSenderVerificationResend = MutationNames.EmailSenderVerificationResend,
    EventDocumentsExport = MutationNames.EventDocumentsExport,
    EventDocumentsExportResult = MutationNames.EventDocumentsExportResult,
    EventLayerUpdate = MutationNames.EventLayerUpdate,
    EventProfilePrivateFieldsUpdate = MutationNames.EventProfilePrivateFieldsUpdate,
    EventWeezeventUpdate = MutationNames.EventWeezeventUpdate,
    ExportResult = MutationNames.ExportResult,
    FormRegister = MutationNames.FormRegister,
    LoginCodeEmailCreate = MutationNames.LoginCodeEmailCreate,
    OrganizationProfilePrivateFieldsUpdate = MutationNames.OrganizationProfilePrivateFieldsUpdate,
    PositionsImportResult = MutationNames.PositionsImportResult,
    SegmentFolderMoveDown = MutationNames.SegmentFolderMoveDown,
    SegmentFolderMoveUp = MutationNames.SegmentFolderMoveUp,
    SegmentMoveDown = MutationNames.SegmentMoveDown,
    SegmentMoveUp = MutationNames.SegmentMoveUp,
    SegmentsFoldersReorder = MutationNames.SegmentsFoldersReorder,
    SkidataConnectionInfoSeaonEventAdd = MutationNames.SkidataConnectionInfoSeaonEventAdd,
    SkidataConnectionInfoSeaonEventDelete = MutationNames.SkidataConnectionInfoSeaonEventDelete,
    SkidataConnectionInfoSynchronizedEventAdd = MutationNames.SkidataConnectionInfoSynchronizedEventAdd,
    SkidataConnectionInfoSynchronizedEventDelete = MutationNames.SkidataConnectionInfoSynchronizedEventDelete,
    SkidataSynchronize = MutationNames.SkidataSynchronize,
    TextMessageRepliesRead = MutationNames.TextMessageRepliesRead,
    TranslationUpdate = MutationNames.TranslationUpdate,
    UserCreate = MutationNames.UserCreate,
    UserDelete = MutationNames.UserDelete,
    UserInfoAdminDelete = MutationNames.UserInfoAdminDelete,
    UserInfoAndTermsUpdate = MutationNames.UserInfoAndTermsUpdate,
    UsersInfosMassDelegationDelete = MutationNames.UsersInfosMassDelegationDelete,
    UserOrganizationUpdate = MutationNames.UserOrganizationUpdate,
    UserPositionCategoryUpdate = MutationNames.UserPositionCategoryUpdate,
    UserPositionUpdate = MutationNames.UserPositionUpdate,
    UserProfileUpdate = MutationNames.UserProfileUpdate,
    UsersInfosExport = MutationNames.UsersInfosExport,
    VolunteersExport = MutationNames.VolunteersExport,
    VolunteersImportResult = MutationNames.VolunteersImportResult
}
